import { createSourcedAction } from '@ces/sourced-action';
import { props } from '@ngrx/store';
import { FrontEndState } from 'egov-api';


export const loadState = createSourcedAction('App state load');
export const stateLoadFailed = createSourcedAction('App state load failed');
export const stateLoaded = createSourcedAction('App state loaded', props<{ newState: FrontEndState }>());
